import { render, staticRenderFns } from "./Challenge.vue?vue&type=template&id=37bf97a6&"
import script from "./Challenge.controller.js?vue&type=script&lang=js&"
export * from "./Challenge.controller.js?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./Challenge.styles.scss?vue&type=style&index=0&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "78725d02"
  
)

export default component.exports